// Thin wrapper around authenticatedFetch for /api/it-assets. Mirrors B2BOrderReview/apiClient.js.
import { authenticatedFetch } from '../AuthComponent';

const BASE = '/api/it-assets';

async function jsonOrThrow(resp) {
  if (!resp.ok) {
    let detail = '';
    try {
      const j = await resp.json();
      detail = typeof j.detail === 'string' ? j.detail : '';
    } catch { /* the status alone is enough */ }
    throw new Error(detail || `${resp.status} ${resp.statusText}`);
  }
  return resp.json();
}

const qs = (o) => {
  const p = new URLSearchParams();
  Object.entries(o || {}).forEach(([k, v]) => { if (v !== '' && v !== null && v !== undefined && v !== false) p.set(k, v); });
  const s = p.toString();
  return s ? `?${s}` : '';
};
const send = (method, path, body) => authenticatedFetch(`${BASE}${path}`, { method, headers: { 'Content-Type': 'application/json' }, body: body === undefined ? undefined : JSON.stringify(body) }).then(jsonOrThrow);
const get = (path, params) => authenticatedFetch(`${BASE}${path}${qs(params)}`).then(jsonOrThrow);

async function blobOf(path) {
  const resp = await authenticatedFetch(`${BASE}${path}`);
  if (!resp.ok) await jsonOrThrow(resp);
  return resp.blob();
}

export const itApi = {
  meta: () => get('/meta'),
  stats: () => get('/stats'),
  assets: (p) => get('/assets', p),
  asset: (id) => get(`/assets/${id}`),
  available: (p) => get('/available', p),
  loans: (p) => get('/loans', p),
  events: () => get('/events'),
  receipts: (p) => get('/receipts', p),
  receipt: (id) => get(`/receipts/${id}`),
  people: (p) => get('/people', p),
  locations: (p) => get('/locations', p),

  checkout: (b) => send('POST', '/assets/checkout', b),
  linkReceipt: (ids, receiptId) => send('POST', '/assets/receipt', { asset_ids: ids, receipt_id: receiptId }),
  deleteAssets: (ids) => send('POST', '/assets/delete', { asset_ids: ids }),
  checkin: (ids, locationId) => send('POST', '/assets/checkin', { asset_ids: ids, location_id: locationId || null }),
  move: (b) => send('POST', '/assets/move', b),
  setStatus: (id, b) => send('POST', `/assets/${id}/status`, b),
  editAsset: (id, b) => send('PATCH', `/assets/${id}`, b),
  scan: (b) => send('POST', '/assets/scan', b),
  saveLogin: (id, login) => send('PUT', `/assets/${id}/login`, { login }),
  revealLogin: (id) => send('POST', `/assets/${id}/login/reveal`),
  addPerson: (b) => send('POST', '/people', b),
  workspaceUsers: (q) => get('/workspace/users', { q }),
  workspaceSync: () => send('POST', '/workspace/sync', {}),
  personFromWorkspace: (email) => send('POST', '/people/from-workspace', { email }),
  editPerson: (id, b) => send('PATCH', `/people/${id}`, b),
  removePerson: (id) => send('DELETE', `/people/${id}`),
  addCard: (b) => send('POST', '/cards', b),
  setCardDigits: (id, b) => send('PATCH', `/cards/${id}`, b),
  addReceipt: (b) => send('POST', '/receipts', b),
  editReceipt: (id, b) => send('PATCH', `/receipts/${id}`, b),
  addEvent: (b) => send('POST', '/events', b),
  addLocation: (b) => send('POST', '/locations', b),
  editLocation: (id, b) => send('PATCH', `/locations/${id}`, b),
  removeLocation: (id, moveTo) => send('POST', `/locations/${id}/remove`, { move_to: moveTo || null }),

  readReceipt: (files) => {
    const fd = new FormData(); files.forEach((f) => fd.append('files', f));
    return authenticatedFetch(`${BASE}/receipts/read`, { method: 'POST', body: fd }).then(jsonOrThrow);
  },
  readSavedReceipt: (id) => send('POST', `/receipts/${id}/read`, {}),
  addReceiptItems: (id, items) => send('POST', `/receipts/${id}/items`, { items }),
  editReceiptItems: (id, b) => send('PUT', `/receipts/${id}/items`, b),
  uploadReceiptPages: (id, files) => {
    const fd = new FormData();
    files.forEach((f) => fd.append('files', f));
    // no content type here: the browser sets the multipart boundary itself
    return authenticatedFetch(`${BASE}/receipts/${id}/files`, { method: 'POST', body: fd }).then(jsonOrThrow);
  },
  receiptPage: (id, fileId) => blobOf(`/receipts/${id}/files/${fileId}`),
  removeReceiptPage: (id, fileId) => send('DELETE', `/receipts/${id}/files/${fileId}`),
  accountingCsv: (p) => blobOf(`/export/accounting${qs(p)}`),
};
